import React, { useState } from 'react'
import TechnologyWorkDeveloper from '../modals/TechnologyDeveloper'

function TechnologiesWork() {
    const [openModal, setOpenModal] = useState(false);
    const [options, setOptions] = useState([])
    const [name, setName] = useState('')
    const toggle = () => {
        setOpenModal(!openModal);
    }
    const handleClick = (technology) => {
        if (technology === 'iOS') {
            setOptions([{
                name: 'iOS', id: 1
            }]);
            setName('iOS')
            toggle()
        }
        if (technology === 'Android') {
            setOptions([{
                name: 'Android', id: 1
            }]);
            setName('Android')
            toggle()
        }
        if (technology === 'Flutter') {
            setOptions([{
                name: 'Flutter', id: 1
            }]);
            setName('Flutter')
            toggle()
        }
        if (technology === 'Java') {
            setOptions([{
                name: 'Java', id: 1
            }]);
            setName('Java')
            toggle()
        }
        if (technology === 'React-native') {
            setOptions([{
                name: 'React-native', id: 1
            }]);
            setName('React-native')
            toggle()
        }
        if (technology === 'Kotlin') {
            setOptions([{
                name: 'Kotlin', id: 1
            }]);
            setName('Kotlin')
            toggle()
        }
        if (technology === 'Objective-C') {
            setOptions([{
                name: 'Objective-C', id: 1
            }]);
            setName('Objective-C')
            toggle()
        }
        if (technology === 'Swift') {
            setOptions([{
                name: 'Swift', id: 1
            }]);
            setName('Swift')
            toggle()
        }
        if (technology === 'Wearables') {
            setOptions([{
                name: 'Wearables', id: 1
            }]);
            setName('Wearables')
            toggle()
        }
    }
    return (
        <section className="r-bg-x zup sec-top-pad" id={'technologies'}>
            <TechnologyWorkDeveloper openModal={openModal} toggle={toggle} name={name} />
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="sec-heading text-center">
                            <h2><span className="ree-text rt40">Technologies</span></h2>
                            <p className='mt30'>Hire a team of professional developers with expertise in the following areas.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center mt30">
                    <div className="col-lg-2 col-md-3 col-sm-4 col-6" style={{ cursor: 'pointer' }} onClick={() => handleClick('iOS')}>
                        <div className="icon-with-title">
                            <a>
                                <div className="iwt-icon"> <img src="images/icons/apple.webp"
                                    alt="Apple" /> </div>
                                <div className="iwt-content">
                                    <p>iOS</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-3 col-sm-4 col-6" style={{ cursor: 'pointer' }} onClick={() => handleClick('Android')}>
                        <div className="icon-with-title">
                            <a>
                                <div className="iwt-icon"> <img src="images/icons/android.webp"
                                    alt="Android" /> </div>
                                <div className="iwt-content">
                                    <p>Android</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-3 col-sm-4 col-6" style={{ cursor: 'pointer' }} onClick={() => handleClick('Flutter')}>
                        <div className="icon-with-title">
                            <a>
                                <div className="iwt-icon"> <img src="images/icons/flutter.webp"
                                    alt="Flutter" /> </div>
                                <div className="iwt-content">
                                    <p>Flutter</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-3 col-sm-4 col-6" style={{ cursor: 'pointer' }} onClick={() => handleClick('Java')}>
                        <div className="icon-with-title">
                            <a>
                                <div className="iwt-icon"> <img src="images/icons/java.webp" alt="Java" />
                                </div>
                                <div className="iwt-content">
                                    <p>Java</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-3 col-sm-4 col-6" style={{ cursor: 'pointer' }} onClick={() => handleClick('React-native')}>
                        <div className="icon-with-title">
                            <a>
                                <div className="iwt-icon"> <img src="images/icons/physics.webp"
                                    alt="React Native" /> </div>
                                <div className="iwt-content">
                                    <p>React Native</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-3 col-sm-4 col-6" style={{ cursor: 'pointer' }} onClick={() => handleClick('Kotlin')}>
                        <div className="icon-with-title">
                            <a>
                                <div className="iwt-icon"> <img src="images/icons/kotlin.webp"
                                    alt="python" /> </div>
                                <div className="iwt-content">
                                    <p>Kotlin</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-3 col-sm-4 col-6" style={{ cursor: 'pointer' }} onClick={() => handleClick('Objective-C')}>
                        <div className="icon-with-title">
                            <a>
                                <div className="iwt-icon"> <img src="images/icons/apple-logo.webp" alt="Java" />
                                </div>
                                <div className="iwt-content">
                                    <p>Objective-C</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-3 col-sm-4 col-6" style={{ cursor: 'pointer' }} onClick={() => handleClick('Swift')}>
                        <div className="icon-with-title">
                            <a>
                                <div className="iwt-icon"> <img src="images/icons/swift.webp"
                                    alt="Apswiftple" /> </div>
                                <div className="iwt-content">
                                    <p>Swift</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-3 col-sm-4 col-6" style={{ cursor: 'pointer' }} onClick={() => handleClick('Wearables')}>
                        <div className="icon-with-title">
                            <a>
                                <div className="iwt-icon"> <img src="images/icons/wearable.webp" alt="pwa" />
                                </div>
                                <div className="iwt-content">
                                    <p>Wearables</p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TechnologiesWork